import CTA1 from './CTA1'
export default CTA1
